import React, { useState } from "react";
import { MedicationsVaccinesStackScreenProps } from "../MedicationsVaccinesNavigator";
import { useSubmitMedicationsVaccines } from "../useSubmitMedicationsVaccines";
import {
  BaseCompleteScreen,
  navigateToNextSection,
  getNextSectionButtonLabel,
} from "@louise/medical-history/components/BaseCompleteScreen";
import { useTranslations } from "@src/packages/i18n";

export function MedicationsVaccinesCompleteScreen({
  navigation,
}: MedicationsVaccinesStackScreenProps<"MedicationsVaccinesComplete">) {
  const t = useTranslations();
  const [saveError, setSaveError] = useState<string | null>(null);
  const { submit, isPending } = useSubmitMedicationsVaccines();

  const handleFinish = async () => {
    try {
      setSaveError(null);
      await submit();
      navigateToNextSection(navigation, "medicationsVaccines");
    } catch {
      // Draft state stays in context; the user retries with the same button.
      // Navigating (or staying silent) here would fake a successful save
      // and drop the answers on the next refetch (#2219).
      setSaveError(t("med_history.save_failed_message"));
    }
  };

  return (
    <BaseCompleteScreen
      saveError={saveError}
      subtitle={t("med_history.medical.medications_vaccines.complete_subtitle")}
      buttonLabel={getNextSectionButtonLabel(t, "medicationsVaccines")}
      isSubmitting={isPending}
      onFinish={handleFinish}
    />
  );
}

export default MedicationsVaccinesCompleteScreen;
